export default __webpack_public_path__ + "static/media/devices.10f62453.png";